import React, { useEffect, useRef, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';
import Excel from 'exceljs';
import axios from 'axios';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import ExcelDropzone from '../Inputs/ExcelDropzone';
import TableBody from '@mui/material/TableBody';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import { cmmUtils } from 'utils/cmmUtils.js';
import Backdrop from '@mui/material/Backdrop';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { LinearProgress } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import wait from 'waait';

const moment = require('moment');

export default function GeoCoding(props) {
  const { open, handleClose, getDataList } = props;
  const [file, setFile] = useState(null);
  const [columns, setColumns] = useState([]);
  const [dataColumns, setDataColumns] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [addressType, setAddressType] = useState('road');
  const [addressColumn, setAddressColumn] = useState(null);
  const [apiKind, setApiKind] = useState('');
  const [publicApiKey, setPublicApiKey] = useState([]);
  const [apiKey, setApiKey] = useState('');
  const [errorMessage, setErrorMessage] = useState(null);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [successCount, setSuccessCount] = useState(0);
  const [errorCount, setErrorCount] = useState(0);
  const [errorList, setErrorList] = useState([]);
  const convertFlag = useRef(true);
  const [count, setCount] = useState(0);
  const convertCount = useRef(0);
  const [nowDate, setNowDate] = useState('');

  const handleDropFile = (acceptedFiles) => {
    setDataColumns([]);
    setDataList([]);
    setFile(null);
    if (acceptedFiles[0].type === 'text/csv') {
      const reader = new FileReader();
      reader.readAsText(acceptedFiles[0], 'EUC-KR');
      reader.onload = () => {
        const csvJson = cmmUtils.csvToJSON(reader.result);
        setDataColumns(reader.result.split('\r\n')[0].split(','));
        setDataList(csvJson);
        setFile(acceptedFiles);
      };
    } else {
      let tempDataList = [];
      let tempColumns = [];
      const workbook = new Excel.Workbook();
      const reader = new FileReader();
      reader.readAsArrayBuffer(acceptedFiles[0]);
      reader.onload = () => {
        const buffer = reader.result;
        workbook.xlsx.load(buffer).then((wb) => {
          wb.eachSheet((sheet, id) => {
            //rowIndex 및 columnIndex 가 1부터 시작하므로 유의.
            sheet.eachRow(async (row, rowIndex) => {
              if (rowIndex === 1) {
                for (let i = 1; i < row.values.length; i++) {
                  tempColumns.push(row.values[i]);
                }
              } else {
                let dataInfo = {};
                for (let i = 1; i < row.values.length; i++) {
                  dataInfo[tempColumns[i - 1]] = row.values[i] !== undefined ? row.values[i] : null;
                }
                tempDataList.push(dataInfo);
              }
            });
          });
          setDataColumns(tempColumns);
          setDataList(tempDataList);
          setFile(acceptedFiles);
        });
      };
    }
  };

  const handleChangeSelect = (e) => {
    setAddressColumn(e.target.value);
  };

  const handleChangeApiKey = (e) => {
    setApiKey(e.target.value);
  };

  const handleChangeAddressType = (e) => {
    setAddressType(e.target.value);
  };

  const handleChangeApiKind = (e) => {
    setApiKey('');
    if (e.target.value === 'public') {
      setApiKey('public');
    } else {
      getApiKey();
    }
    setApiKind(e.target.value);
  };

  const convertGeoCoding = async (data) => {
    let addressList = [];
    let errorList = [];
    if (!apiKey) {
      setErrorMessage('API KEY를 입력해주세요.');
      return;
    }

    if (dataList.length <= 0) {
      setErrorMessage('파일을 먼저 선택해주세요.');
      return;
    }
    if (!addressColumn && addressColumn !== 0) {
      setErrorMessage('주소 필드를 선택해주세요.');
      return;
    }

    setErrorMessage('');

    convertFlag.current = true;
    setNowDate(moment(new Date()).format('YYYY-MM-DD hh:mm:ss'));
    setBackdropOpen(true);

    dataList.map((row) => {
      row.address = eval(`row["${dataColumns[addressColumn]}"]`);
      addressList.push(row);
    });

    await getGeoCodeList(addressList)
      .then((result) => {
        let features = [];
        result.map((data, index) => {
          if (data.status === 'OK') {
            let feature = {};
            feature.type = 'Feature';
            feature.geometry = {};
            feature.geometry.type = 'Point';
            feature.geometry.coordinates = [Number(data.point.x), Number(data.point.y)];
            feature.properties = data;
            features.push(feature);
          } else {
            data.에러메세지 = data.status;
            errorList.push(data);
            setErrorCount(errorList.length);
          }
        });

        let data = {};
        data.type = 'geo';
        data.features = features;
        data.fileName = `${file[0].path.substring(0, file[0].path.lastIndexOf('.'))}.zip`;
        data.errorList = errorList;
        data.dataColumns = dataColumns;
        data.errorCount = errorList.length;
        data.apiKey = apiKey;
        convertShp(data);
      })
      .catch((e) => {
        alert('변환 실패!');
        console.log(e);
        setBackdropOpen(false);
      })
      .finally(() => {
        setBackdropOpen(false);
      });
  };

  const getGeoCodeList = async (addressList) => {
    let tmpSuccessCount = 0;
    let tmpErrorCount = 0;
    let resultAddressList = [];
    let tmpErrorList = [];
    let error502List = [];
    for (let i = 0; i < addressList.length; i++) {
      if (convertFlag.current) {
        const address = addressList[i];
        await wait(100).then(async () => {
          await convertGeoCode(address.address).then(async (result) => {
            address.point = await result?.point;
            address.status = await result?.status;

            if (result?.status === 'OK') {
              tmpSuccessCount = tmpSuccessCount + 1;
              resultAddressList.push(address);
            } else if (result?.status.indexOf('502') > 0) {
              error502List.push(address);
            } else {
              tmpErrorCount = tmpErrorCount + 1;
              address.status = result.status;
              tmpErrorList.push(address);
              resultAddressList.push(address);
            }
          });
          setSuccessCount(tmpSuccessCount);
          setErrorList(tmpErrorList);
          setErrorCount(tmpErrorCount);
        });
      } else {
        break;
      }
    }

    while (error502List.length > 0 && convertFlag.current) {
      const error502Length = error502List.length;
      error502List = [];
      for (let i = 0; i < error502Length; i++) {
        if (convertFlag.current) {
          const address = addressList[i];
          await wait(1000).then(async () => {
            await convertGeoCode(address.address).then(async (result) => {
              address.point = await result?.point;
              address.status = await result?.status;

              if (result?.status === 'OK') {
                tmpSuccessCount = tmpSuccessCount + 1;
                resultAddressList.push(address);
              } else if (result?.status.indexOf('502') > 0) {
                error502List.push(address);
              } else {
                tmpErrorCount = tmpErrorCount + 1;
                address.status = result.status;
                tmpErrorList.push(address);
                resultAddressList.push(address);
              }
            });
            setSuccessCount(tmpSuccessCount);
            setErrorList(tmpErrorList);
            setErrorCount(tmpErrorCount);
          });
        } else {
          break;
        }
      }
    }

    return resultAddressList;
  };

  const convertGeoCode = async (address) => {
    if (address.indexOf('(') > 0) {
      address = address.substring(0, address.indexOf('('));
    }
    return await refineAddress(address)
      .then(async (refinedAddress) => {
        if (refinedAddress.status === 'OK') {
          if (refinedAddress.result.items.length > 0) {
            const item = refinedAddress.result.items[0];
            return await axios
              .get(
                encodeURI(
                  `${process.env.REACT_APP_VWORLD_GEO_CODE_API_URL}?service=address&request=getcoord&address=${item.address.parcel ? item.address.parcel : item.address.road}&refine=true&simple=true&format=json&type=${
                    item.address.parcel ? 'parcel' : 'road'
                  }&key=${apiKind === 'public' ? publicApiKey[Math.floor(convertCount.current / 39000)].apiKey : apiKey}`
                ),
                {
                  headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': '*',
                    'Access-Control-Allow-Credentials': 'true'
                  }
                }
              )
              .then(async (result) => {
                await axios.patch(`/api/geo-code/incrementCount`, { apiKey: apiKey }).then((result) => {
                  convertCount.current = result.data.count;
                  setCount(convertCount.current);
                });
                if (result.data.response.result) {
                  result.data.response.result.status = 'OK';
                  return await result.data.response.result;
                } else {
                  return await axios
                    .get(
                      encodeURI(
                        `${process.env.REACT_APP_VWORLD_GEO_CODE_API_URL}?service=address&request=getcoord&address=${item.address.road ? item.address.road : item.address.parcel}&refine=true&simple=true&format=json&type=${
                          item.address.road ? 'road' : 'parcel'
                        }&key=${apiKind === 'public' ? publicApiKey[Math.floor(convertCount.current / 39000)].apiKey : apiKey}`
                      ),
                      {
                        headers: {
                          'Access-Control-Allow-Origin': '*',
                          'Access-Control-Allow-Headers': '*',
                          'Access-Control-Allow-Credentials': 'true'
                        }
                      }
                    )
                    .then(async (result) => {
                      await axios.patch(`/api/geo-code/incrementCount`, { apiKey: apiKey }).then((result) => {
                        convertCount.current = result.data.count;
                        setCount(convertCount.current);
                      });
                      if (result.data.response.result) {
                        result.data.response.result.status = 'OK';
                        return await result.data.response.result;
                      } else {
                        return { status: result.data.response.status };
                      }
                    })
                    .catch((error) => {
                      return { status: error.message };
                    });
                }
              })
              .catch((error) => {
                return { status: error.message };
              });
          }
        } else {
          return await refinedAddress;
        }
      })
      .catch((error) => {
        return { status: error.message };
      });
  };

  const convertCancel = async () => {
    if (window.confirm('중지 후 재시작 할 수 없습니다. 진행하시겠습니까?')) {
      convertFlag.current = false;
      setBackdropOpen(false);
    }
  };

  const refineAddress = async (address) => {
    let type = addressType;
    return await axios
      .get(
        encodeURI(
          `${process.env.REACT_APP_VWORLD_REFINE_ADDRESS_API_URL}?service=search&request=search&version=2.0&query=${address}&type=address&category=${type}&format=json&errorformat=json&key=${
            apiKind === 'public' ? publicApiKey[Math.floor(convertCount.current / 39000)].apiKey : apiKey
          }`
        ),
        {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Credentials': 'true'
          }
        }
      )
      .then(async (result) => {
        if (result.data?.response?.status === 'NOT_FOUND') {
          if (type.toLowerCase() === 'parcel') {
            type = 'road';
          } else {
            type = 'parcel';
          }
          return await axios
            .get(
              encodeURI(
                `${process.env.REACT_APP_VWORLD_REFINE_ADDRESS_API_URL}?service=search&request=search&version=2.0&query=${address}&type=address&category=${type}&format=json&errorformat=json&key=${
                  apiKind === 'public' ? publicApiKey[Math.floor(convertCount.current / 39000)].apiKey : apiKey
                }`
              ),
              {
                headers: {
                  'Access-Control-Allow-Origin': '*',
                  'Access-Control-Allow-Headers': '*',
                  'Access-Control-Allow-Credentials': 'true'
                }
              }
            )
            .then(async (result) => {
              if (result.data?.response?.status === 'OK') {
                if (type.toLowerCase() === 'parcel') {
                  if (result.data.response.result.items[0].address.parcel.replace(/ /g, '').indexOf(address.substring(0, address.indexOf(' ', address.indexOf(' ') + 1)).replace(/ /g, '')) < 0) {
                    return { address: address, status: 'NOT_FOUND' };
                  }
                } else {
                  if (result.data.response.result.items[0].address.road.replace(/ /g, '').indexOf(address.substring(0, address.indexOf(' ', address.indexOf(' ') + 1)).replace(/ /g, '')) < 0) {
                    return { address: address, status: 'NOT_FOUND' };
                  }
                }
              }
              return await result.data.response;
            })
            .catch((error) => {
              return { status: error.message };
            });
        }
        if (result.data?.response?.status === 'OK') {
          if (type.toLowerCase() === 'parcel') {
            if (result.data.response.result.items[0].address.parcel.replace(/ /g, '').indexOf(address.substring(0, address.indexOf(' ', address.indexOf(' ') + 1)).replace(/ /g, '')) < 0) {
              return { address: address, status: 'NOT_FOUND' };
            }
          } else {
            if (result.data.response.result.items[0].address.road.replace(/ /g, '').indexOf(address.substring(0, address.indexOf(' ', address.indexOf(' ') + 1)).replace(/ /g, '')) < 0) {
              return { address: address, status: 'NOT_FOUND' };
            }
          }
        }
        return await result.data.response;
      })
      .catch((error) => {
        return { address: address, status: error.message };
      });
  };

  const convertShp = async (data) => {
    if (data.features.length > 0) {
      await axios
        .post(`/api/geo-code/convert`, data, { responseType: 'blob' })
        .then(async (response) => {
          let blob = new Blob([response.data], {
            type: <response className="headers"></response>
          });
          let name = getFileName(decodeURIComponent(response.headers['content-disposition']));
          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, name);
          } else {
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.target = '_self';
            if (name) link.download = name;
            link.click();
            window.URL.revokeObjectURL(link);
            alert(`성공 : ${data.features.length}건\r\n실패 : ${data.errorList.length}건`);
            await handleClose();
            await getDataList();
          }
        })
        .catch((error) => {
          alert('변환 실패!');
          console.log(error);
          setBackdropOpen(false);
        })
        .finally(() => {
          setBackdropOpen(false);
        });
    } else {
      alert(`성공 : ${data.features.length}건\r\n실패 : ${data.errorList.length}건`);
      await handleClose();
      await getDataList();
    }
  };

  const getFileName = (contentDisposition) => {
    let fileName = contentDisposition
      .split(';')
      .filter((el) => el.indexOf('filename') > -1)
      .map((ele) => ele.replace(/"/g, '').split('=')[1]);
    return fileName[0];
  };

  const getApiKey = async () => {
    await axios.get(`/api/geo-code/key`).then(async (result) => {
      if (result?.data?.apiKey) {
        setApiKey(result.data.apiKey);
        setApiKind('private');
      }
    });
  };

  const getPublicApiKey = async () => {
    await axios.get(`/api/geo-code/publicKey`).then(async (result) => {
      if (result?.data.length > 0) {
        setPublicApiKey(result.data);
      }
    });
  };

  const getCount = async () => {
    if (apiKey !== '') {
      await axios.get(`/api/geo-code/count/${apiKey}`).then((result) => {
        if (result.data) {
          convertCount.current = result.data.count;
        } else {
          convertCount.current = 0;
        }
      });
    } else {
      convertCount.current = 0;
    }
    setCount(convertCount.current);
  };

  useEffect(async () => {
    await getCount();
  }, [apiKey]);

  useEffect(async () => {
    let tempColumns = [];
    dataColumns.map((dataColumn, idx) => {
      tempColumns.push({ id: dataColumn, label: dataColumn, align: 'center' });
    });
    setColumns(tempColumns);
  }, [dataColumns]);

  useEffect(async () => {
    if (open) {
      setApiKey('public');
      setApiKind('public');
      setFile(null);
      setDataColumns([]);
      setColumns([]);
      setDataList([]);
      setAddressType('road');
      setAddressColumn(null);
      setErrorMessage(null);
      setSuccessCount(0);
      setErrorList([]);
      setErrorCount(0);
      setBackdropOpen(false);
      convertFlag.current = true;
      setNowDate('');
      getApiKey();
      getPublicApiKey();
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="draggable-dialog-title" maxWidth="1500">
      <Box component="form" noValidate sx={{ mt: 1, minWidth: 600 }}>
        <DialogTitle id="draggable-dialog-title">지오코딩 (주소 → 좌표)</DialogTitle>
        <DialogContent dividers>
          <Box>
            <Typography variant="h6" display="inline" gutterBottom>
              ※ V-WORLD API KEY 받는 법
            </Typography>
            <br />
            <Box sx={{ ml: 3 }}>
              <Typography variant="body3" display="inline">
                1.{' '}
                <a href="https://www.vworld.kr/" target="_blank">
                  V-WORLD
                </a>{' '}
                회원가입
                <br />
                2. 로그인 후{' '}
                <a href="https://www.vworld.kr/dev/v4dv_apikey_s001.do" target="_blank">
                  V-WORLD 오픈 API 인증키 발급 페이지
                </a>{' '}
                접속
                <br />
                3. 서비스유형 - 웹사이트
                <br />
                <Box sx={{ ml: 2 }}>
                  서비스 URL - https://pgm.dohwa.co.kr
                  <br />
                  브이월드 활용API - 지오코더 API, 검색 API
                  <br />
                  사용기관 - 민간
                  <br />
                  입력 후 [지도 인증키 받기] 버튼 클릭
                </Box>
              </Typography>
            </Box>
          </Box>
          <Divider sx={{ mb: 3 }} />
          <Box>
            <TableContainer component={'div'}>
              <Table size="small">
                <TableRow>
                  <TableCell sx={{ width: 130 }}>API KEY 종류</TableCell>
                  <TableCell>
                    <RadioGroup row name="apiKind" id="apiKind" value={apiKind || 'public'} onChange={handleChangeApiKind}>
                      <FormControlLabel key="public" value="public" control={<Radio />} label="공용" />
                      <FormControlLabel key="private" value="private" control={<Radio />} label="개인" />
                    </RadioGroup>
                  </TableCell>
                </TableRow>
                {apiKind !== 'public' && (
                  <TableRow>
                    <TableCell sx={{ width: 100 }}>API KEY</TableCell>
                    <TableCell>
                      <TextField id="apiKey" variant="outlined" size="small" fullWidth value={apiKey} onChange={handleChangeApiKey} />
                    </TableCell>
                  </TableRow>
                )}
                <TableRow>
                  <TableCell>오늘 변환 건수</TableCell>
                  <TableCell>
                    {numberWithCommas(count || 0)}
                    <Typography variant="body5" display="inline" gutterBottom sx={{ ml: 2, color: 'red' }}>
                      {apiKind === 'public' ? `(공용 API KEY ${numberWithCommas(39000 * publicApiKey.length)}건 가능)` : `(KEY 하나당 40,000건 변환 가능)`}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </Table>
            </TableContainer>
            <TableContainer component={'div'} sx={{ mt: 3 }}>
              <Table size="small">
                <TableRow>
                  <TableCell sx={{ width: 130 }}>주소 필드</TableCell>
                  <TableCell>
                    {dataColumns.length > 0 && (
                      <FormControl sx={{ minWidth: 300 }}>
                        <InputLabel id="label">주소 필드</InputLabel>
                        <Select labelId="label" id="addressColumn" name="addressColumn" value={addressColumn} label="주소 필드" onChange={handleChangeSelect} fullWidth size={'small'}>
                          {dataColumns.map((item, idx) => {
                            return (
                              <MenuItem key={`${idx}`} value={idx}>
                                <ListItemText primary={`${item}`} />
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    )}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>주소 종류</TableCell>
                  <TableCell>
                    {dataColumns.length > 0 && (
                      <RadioGroup row name="addressType" id="addressType" value={addressType || 'road'} onChange={handleChangeAddressType}>
                        <FormControlLabel key="true" value="road" control={<Radio />} label="도로명" />
                        <FormControlLabel key="false" value="parcel" control={<Radio />} label="지번" />
                      </RadioGroup>
                    )}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>건수</TableCell>
                  <TableCell>
                    {dataList.length > 0 && `${numberWithCommas(dataList.length)} (예상 소요시간 - 약 ${numberWithCommas(Math.ceil(dataList.length > 60 ? dataList.length / 60 : dataList.length))}${dataList.length > 60 ? '분' : '초'})`}
                  </TableCell>
                </TableRow>
              </Table>
            </TableContainer>
          </Box>
          <Box sx={{ mt: 3 }}>
            <TableContainer component={'div'}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell key={column.id} align={column.align} sx={{ minWidth: column.minWidth }}>
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataList.slice(0, 5).map((row, rowIdx) => (
                    <TableRow hover key={row.id}>
                      {columns.map((col, colIdx) => {
                        return (
                          <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                            {typeof row[col.id] === 'object' ? moment(row[col.id]).format('YYYY-MM-DD') : row[col.id]}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))}
                  {dataList.length > 0 ? (
                    <TableRow>
                      <TableCell colSpan={columns.length} align={'center'}>
                        ⠇
                      </TableCell>
                    </TableRow>
                  ) : (
                    <TableRow hover></TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Box sx={{ mt: 3 }}>
            <ExcelDropzone
              accept={{
                'text/csv': ['.csv'],
                'application/vnd.ms-excel': ['xlsx'],
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xls']
              }}
              onAcceptedFiles={handleDropFile}
              id="panorama"
              maxFiles={1}
              maxFilesize={5242880}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <span style={{ color: 'red', fontSize: 'small', margin: '10px 10px 0px 10px' }}>{errorMessage}</span>
          <Button variant="contained" color="primary" onClick={convertGeoCoding}>
            변환
          </Button>
          <Button variant="outlined" color="success" onClick={handleClose}>
            닫기
          </Button>
        </DialogActions>
      </Box>
      <Backdrop open={backdropOpen}>
        <LinearProgressWithLabel totalCount={dataList.length} successCount={successCount} errorCount={errorCount} convertCancel={convertCancel} errorList={errorList} nowDate={nowDate} />
      </Backdrop>
    </Dialog>
  );
}

const LinearProgressWithLabel = (props) => {
  return (
    <Box sx={{ zIndex: 5000 }}>
      <Card variant="outlined" sx={{ width: 500, height: 145, backgroundColor: 'white' }}>
        <CardContent sx={{ pb: 0, pt: 2 }}>
          <Typography sx={{ fontSize: 14 }} gutterBottom>
            변환 중 (총 {props.totalCount} / 성공 {props.successCount} / 실패 {props.errorCount})
            <br />
            시작 시간 : {props.nowDate} (예상 소요시간 - 약 {numberWithCommas(Math.ceil(props.totalCount > 60 ? props.totalCount / 60 : props.totalCount))}
            {props.totalCount > 60 ? '분' : '초'})
          </Typography>
          <Divider />
          <Box display="flex" alignItems="center" sx={{ mt: 1 }}>
            <Box sx={{ width: '90%', ml: 1, mr: 1 }}>
              <LinearProgress variant="determinate" value={Math.round(((props.successCount + props.errorCount) / props.totalCount) * 100)} />
            </Box>
            <Box minWidth={35}>
              <Typography variant="body2" color="textSecondary">{`${Math.round(((props.successCount + props.errorCount) / props.totalCount) * 100)}%`}</Typography>
            </Box>
          </Box>
          <Divider sx={{ mb: 1 }} />
          <Button variant="contained" color="error" onClick={props.convertCancel} fullWidth>
            중지
          </Button>
        </CardContent>
      </Card>
      {props.errorList.length > 0 && (
        <Card variant="outlined" sx={{ width: 500, backgroundColor: 'white', zIndex: 3500 }}>
          <CardContent sx={{ pb: 0, pt: 2 }}>
            <Typography sx={{ fontSize: 14 }} gutterBottom>
              실패 목록({props.errorList.length}건)
            </Typography>
            <Divider />
            <TableContainer component={'div'} sx={{ overflowY: 'scroll', maxHeight: 300 }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: 300 }} align={'center'}>
                      주소
                    </TableCell>
                    <TableCell align={'center'}>실패 사유</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {props.errorList.map((row, rowIdx) => (
                    <TableRow hover key={row.id}>
                      <TableCell>{row.address}</TableCell>
                      <TableCell>{row.status}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

const numberWithCommas = (x) => {
  return Number(x)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
